import { createSearchParams, type To } from 'react-router-dom';

import { replaceUrlParams } from '~/common/utils/utils';

export type RouteOptions = {
  routeParams?: RouteParams;
  searchParams?: SearchParams;
};

type RouteParams = { [key: string]: string };

type SearchParams = { [key: string]: string };

const createPath = (route: string, options?: RouteOptions): To => {
  const pathname = options?.routeParams ? replaceUrlParams(route, options.routeParams) : route;
  const search = options?.searchParams
    ? createSearchParams(options.searchParams).toString()
    : undefined;

  return { pathname, search };
};

const joinPath = (path: To) => {
  if (typeof path === 'string') return path;

  let url = path.pathname ?? '';

  if (path.search) url += `?${path.search}`;
  if (path.hash) url += `#${path.hash}`;

  return url;
};

const createURL = (route: string, options?: RouteOptions) => {
  const path = createPath(route, options);

  return joinPath(path);
};

export { createPath, createURL, joinPath };
